$('.carousel-thumb-slide').each(function(){
	let itens 	= $(this).find('.carousel-item');
	let id 		= $(this).attr('id');

	if(itens.length <= 1) {
		$(this).find('.controls').hide();
	}
});

$('.carousel-thumb-slide').on('slid.bs.carousel', function(event){
	let _this 		= $(this);
	let direction 	= event.direction;
	let indicator 	= _this.find('.carousel-indicators');
	let active 		= indicator.find('.active');
	let pos 		= active.offset().left;

	let li 			= this.querySelector('.carousel-indicators li.active');

	indicator.animate({
		scrollLeft: li.offsetLeft
	},300);
});